import { makeStyles as makeStyles5 } from '@mui/styles'
import { ClassNameMap, Styles, WithStylesOptions } from '@mui/styles/withStyles'
import { BaseThemeType } from '../theme/BaseTheme'

/**
 * This helper is deprectated and must be removed before we can transition to React 18.
 * It will be useful in the meantime to allow us to upgrade existing components/pages to MUI5 / OS3.0.
 *
 * For new components/pages, please instead use the `styled` helper from `opensolar-ui`.
 *
 * @deprecated
 */
export const makeStyles = <Props extends object = {}, ClassKey extends string = string>(
  styles: Styles<BaseThemeType, Props, ClassKey>,
  options?: Omit<WithStylesOptions<BaseThemeType>, 'withTheme'>
): keyof Props extends never // `makeStyles` where the passed `styles` do not depend on props
  ? (props?: any) => ClassNameMap<ClassKey> // `makeStyles` where the passed `styles` do depend on props
  : (props: Props) => ClassNameMap<ClassKey> => {
  return makeStyles5<BaseThemeType, Props, ClassKey>(styles, options)
}
